module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "grid fixed h100",
    staticStyle: {
      "grid-template-columns": "auto 1fr auto",
      "grid-template-rows": "auto auto"
    }
  }, [_c('navbar', {
    attrs: {
      "hotel": _vm.hotel,
      "settings": _vm.settings,
      "ombrelli": _vm.ombrelli,
      "getOmbrelli": _vm.getOmbrelli
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "grid",
      "justify-items": "center",
      "align-content": "start",
      "overflow": "auto",
      "height": "100vh",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "grid range"
  }, [_c('div', {
    staticClass: "selector"
  }, [_c('p', [(!_vm.nogrid) ? _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "Pick a day",
      "picker-options": _vm.datePickerOptions,
      "format": "dd-MM-yyyy"
    },
    on: {
      "change": function($event) {
        return _vm.changeDate()
      }
    },
    model: {
      value: (_vm.today),
      callback: function($$v) {
        _vm.today = $$v
      },
      expression: "today"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.nogrid) ? _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "al",
      "start-placeholder": "Data inizio",
      "end-placeholder": "Data fine",
      "picker-options": _vm.datePickerOptions,
      "format": "dd-MM-yyyy"
    },
    on: {
      "change": function($event) {
        return _vm.changeRange()
      }
    },
    model: {
      value: (_vm.rangepicker),
      callback: function($$v) {
        _vm.rangepicker = $$v
      },
      expression: "rangepicker"
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "grid thegrid",
    style: (_vm.style)
  }, [_vm._l((_vm.ombrelli), function(ombrello, index) {
    return (_vm.rangeview) ? _c('div', {
      staticClass: "grid ombrello"
    }, [_c('div', {
      staticClass: "grid seat range"
    }, [_c('div', {
      staticClass: "grid data"
    }, [_c('div', {
      staticClass: "grid nr"
    }, [_vm._v(_vm._s(ombrello.ombrid))])]), _vm._v(" "), _c('div', {
      staticClass: "grid days",
      staticStyle: {
        "grid-template-columns": "repeat(7, 1fr)"
      }
    }, _vm._l((ombrello.dates), function(day, indexd) {
      return _c('div', {
        staticClass: "grid"
      }, [(!day.free) ? _c('span', {
        staticClass: "grid day",
        on: {
          "click": function($event) {
            return _vm.bookedshow(ombrello, day)
          }
        }
      }, [_c('el-popover', {
        attrs: {
          "placement": "top-start",
          "title": 'Dettagli ombrello ' + ombrello.ombrid,
          "width": "auto",
          "trigger": "hover",
          "fit": "true"
        }
      }, [_c('el-table', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "data": day.guests
        }
      }, [_c('el-table-column', {
        attrs: {
          "width": "auto",
          "property": "room",
          "label": "Stanza"
        }
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "min-width": 100,
          "property": "name",
          "label": "Nome"
        }
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "width": "120",
          "property": "arrival",
          "label": "Arrivo"
        }
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "width": "120",
          "property": "departure",
          "label": "Partenza"
        }
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "width": "auto",
          "property": "note",
          "label": "Note"
        }
      })], 1), _vm._v(" "), _c('el-button', {
        attrs: {
          "slot": "reference"
        },
        slot: "reference"
      }, [_vm._v(_vm._s(day.date))])], 1)], 1) : _vm._e(), _vm._v(" "), (day.free) ? _c('span', {
        staticClass: "grid day free",
        on: {
          "click": function($event) {
            return _vm.newshow(ombrello, day)
          }
        }
      }, [_vm._v(_vm._s(day.date))]) : _vm._e()])
    }), 0)])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.ombrelli), function(ombrello, index) {
    return (!_vm.rangeview) ? _c('div', {
      staticClass: "grid ombrello drag",
      class: {
        nonvisible: !ombrello.visible
      }
    }, [(!ombrello.free) ? _c('div', {
      staticClass: "grid seat",
      class: {
        minimal: !_vm.hotel.poolsettings.chairs
      },
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_c('div', {
      staticClass: "grid header",
      class: {
        hidden: !_vm.hotel.poolsettings.chairs
      }
    }, [_c('div', {
      staticClass: "grid items"
    }, _vm._l((ombrello.guestsinday[0].items), function(item) {
      return _c('div', {
        staticClass: "grid item"
      }, [(item.num > 0) ? _c('div', {
        staticClass: "grid details"
      }, _vm._l((item.num), function(nu) {
        return _c('span', {
          staticClass: "icon",
          domProps: {
            "innerHTML": _vm._s(item.icon)
          }
        })
      }), 0) : _vm._e()])
    }), 0)]), _vm._v(" "), (!_vm.hotel.poolsettings.guest && !_vm.hotel.poolsettings.room) ? _c('el-popover', {
      attrs: {
        "placement": "top-start",
        "title": 'Dettagli ombrello ' + ombrello.ombrid,
        "width": "auto",
        "trigger": "hover",
        "fit": "true",
        "content": ombrello.guestsinday[0].name
      }
    }, [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": ombrello.guestsinday
      }
    }, [_c('el-table-column', {
      attrs: {
        "width": "auto",
        "property": "room",
        "label": "Stanza"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "min-width": 100,
        "property": "name",
        "label": "Nome"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "120",
        "property": "arrival",
        "label": "Arrivo"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "120",
        "property": "departure",
        "label": "Partenza"
      }
    })], 1), _vm._v(" "), _c('el-button', {
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }, [_c('i', {
      staticClass: "fas fa-info-circle"
    })])], 1) : _vm._e(), _vm._v(" "), (_vm.hotel.poolsettings.room || _vm.hotel.poolsettings.guest) ? _c('div', {
      staticClass: "grid ident"
    }, [(_vm.hotel.poolsettings.room) ? _c('span', {
      staticClass: "room"
    }, [_vm._v(_vm._s(ombrello.guestsinday[0].room))]) : _vm._e(), _vm._v(" "), (ombrello.guest && _vm.hotel.poolsettings.guest) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_vm._v(_vm._s(ombrello.guestsinday[0].name))]) : _vm._e(), _vm._v(" "), (!ombrello.guest && _vm.hotel.poolsettings.guest) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_vm._v("no guest name")]) : _vm._e(), _vm._v(" "), (ombrello.guestsinday.length > 1) ? _c('span', {
      staticClass: "room"
    }, [_vm._v(_vm._s(ombrello.guestsinday[1].room))]) : _vm._e(), _vm._v(" "), (ombrello.guest && ombrello.guestsinday.length > 1) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_vm._v(_vm._s(ombrello.guestsinday[1].name))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "grid data",
      class: {
        minimal: !_vm.hotel.poolsettings.chairs || !_vm.hotel.poolsettings.beds, hidden: !_vm.hotel.poolsettings.arrival
      }
    }, [_c('div', {
      staticClass: "grid nr"
    }, [_vm._v(_vm._s(ombrello.ombrid))]), _vm._v(" "), (_vm.hotel.poolsettings.arrival || _vm.hotel.poolsettings.departure) ? _c('div', {
      staticClass: "grid date",
      class: {
        hidden: !_vm.hotel.poolsettings.arrival
      }
    }, [_c('span', [_c('span', {
      staticClass: "fa fa-chevron-right"
    }), _vm._v(" " + _vm._s(ombrello.arrival))]), _vm._v(" "), _c('span', [_c('span', {
      staticClass: "fa fa-chevron-left"
    }), _vm._v(" " + _vm._s(ombrello.departure))])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (ombrello.free) ? _c('div', {
      staticClass: "blocco seat free",
      attrs: {
        "id": ombrello._id
      },
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_c('a', {
      staticClass: "blocco nr",
      attrs: {
        "id": ombrello._id
      }
    }, [_vm._v(_vm._s(ombrello.ombrid))])]) : _vm._e()]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "grid overview"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Nome ospite o numero camera"
    },
    model: {
      value: (_vm.query),
      callback: function($$v) {
        _vm.query = $$v
      },
      expression: "query"
    }
  }), _vm._v(" "), (_vm.overview.arrivals.length > 0) ? _c('h3', [_vm._v("Check In")]) : _vm._e(), _vm._v(" "), (_vm.overview.arrivals.length > 0) ? _c('div', {
    staticClass: "grid arrivals"
  }, _vm._l((_vm.filteredArrivals), function(arrival) {
    return _c('span', {
      staticClass: "arrival"
    }, [_vm._v(_vm._s(arrival.ombrello.ombrid) + " - " + _vm._s(arrival.guest.name) + "@" + _vm._s(arrival.guest.room))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.overview.departures.length > 0) ? _c('h3', [_vm._v("Check Out")]) : _vm._e(), _vm._v(" "), (_vm.overview.departures.length > 0) ? _c('div', {
    staticClass: "grid departures"
  }, _vm._l((_vm.filteredDepartures), function(departure, index) {
    return _c('span', {
      staticClass: "departure",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.open('overviewdetail', departure, index)
        }
      }
    }, [_vm._v(_vm._s(departure.ombrello.ombrid) + " - " + _vm._s(departure.guest.name) + "@" + _vm._s(departure.guest.room) + " ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('div', {
    staticClass: "grid stays"
  }, _vm._l((_vm.filteredStays), function(stay) {
    return _c('span', {
      staticClass: "stay"
    }, [_vm._v(_vm._s(stay.ombrello.ombrid) + " - " + _vm._s(stay.guest.name) + "@" + _vm._s(stay.guest.room))])
  }), 0)], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "overviewdetail",
      "width": 360,
      "minWidth": 360,
      "maxWidth": 1040,
      "height": "auto",
      "adaptive": true,
      "scrollable": ""
    }
  }, [(!_vm.loading && _vm.checkoutbasket) ? _c('div', {
    staticClass: "grid overviewdetail"
  }, [_c('h1', [_vm._v("Checkout " + _vm._s(_vm.checkoutbasket.ombrid))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('small', [_vm._v("Ospite")]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.checkoutbasket.guests[0].name))])]), _vm._v(" "), _c('div', {
    staticClass: "spacer xs"
  }), _vm._v(" "), _c('small', [_vm._v("Camera")]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.checkoutbasket.guests[0].room))])]), _vm._v(" "), _c('div', {
    staticClass: "spacer xs"
  }), _vm._v(" "), _c('small', [_vm._v("Arrivo")]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.checkoutbasket.guests[0].arrival))])]), _vm._v(" "), _c('div', {
    staticClass: "spacer xs"
  }), _vm._v(" "), _c('small', [_vm._v("Partenza")]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.checkoutbasket.guests[0].departure))])]), _vm._v(" "), _c('div', {
    staticClass: "spacer xs"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.checkoutbasket.guests[0].note))]), _vm._v(" "), _c('div', {
    staticClass: "spacer xs"
  }), _vm._v(" "), _c('div', {
    staticClass: "grid items"
  }, _vm._l((_vm.checkoutbasket.guests[0].items), function(item) {
    return _c('div', {
      staticClass: "grid item"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.num))])])
  }), 0), _vm._v(" "), (_vm.hotel.cashier && _vm.checkoutbasket.cashable && _vm.hotel.seasons.length !== 0) ? _c('div', {
    staticClass: "grid total"
  }, [_c('span', [_c('small', [_vm._v("Base")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_c('small', [_vm._v("€ " + _vm._s(_vm.cashierbasket.tocash))])]), _vm._v(" "), _c('span', [_c('small', [_vm._v("Extra")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_c('small', [_vm._v("€ " + _vm._s(_vm.cashierbasket.extra))])]), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Totale:")])]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_c('strong', [_vm._v("€ " + _vm._s(_vm.cashierbasket.total))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), (_vm.hotel.cashier && _vm.hotel.seasons.length !== 0) ? _c('button', {
    staticClass: "btn btn-green",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fas fa-check-circle"
  }), _vm._v(" Checkout Ospite")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('Hello', {
    attrs: {
      "ombrellos": _vm.ombrellos,
      "hotel": _vm.hotel,
      "disabledDates": _vm.disabledDates,
      "range": _vm.range
    },
    on: {
      "changeOmbrellodate": _vm.onChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bf2b7d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ombrelli.vue
// module id = 622
// module chunks = 1